export enum DocumentTypeEnum {
  USEFUL_LINK = 'UsefulLink',
}

export enum DocumentFileTypeEnum {
  PDF = 'pdf',
  XLS = 'xls',
  PS = 'ps',
}
